import { defineComponent, h } from 'vue';
import { coming_soon } from '@components/icons';
import BarButton from '@components/bar-button';
import show_hidden_edges_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/hide_edges_hidden.svg';
import { img } from '@phi/components';
import ShowHiddenEdgesTooltip from './ShowHiddenEdgesTooltip';

export default defineComponent({
    props: {
        tut_stage: {
            required: true,
            type: Number
        },
        hidden_edges_visible: {
            required: true,
            type: Boolean,
        },
        loaded: {
            required: true,
            type: Boolean,
        },
    },

    computed: {
        coming_soon() {
            return !this.loaded;
        },

        alt() {
            return 'Show hidden edges';
        }
    },

    emits: {
        'update:hidden_edges_visible': (x: boolean) => true,
    },

    render() {
        return h(BarButton, {
            id: 'show-hidden-edges-button',
            disabled: false,
            active: this.hidden_edges_visible,
            tippy: 'right',
            onClick: () => this.$emit('update:hidden_edges_visible', !this.hidden_edges_visible),
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(show_hidden_edges_svg, this.alt),
            tooltip: ShowHiddenEdgesTooltip,
        });
    },
});
